import { Label, type LabelProps as AriaLabelProps } from "react-aria-components";
import React from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export type LabelProps = {
  isInvalid?: boolean;
  isRequired?: boolean;
  label: string;
} & AriaLabelProps;

export function Label2({ className, isInvalid, isRequired, label, ...props }: LabelProps) {
  const { body } = labelStyles();

  return (
    <Label
      className={cn(
        body(),
        "input-label-placeholder",
        className,
        isInvalid && "tw:text-text-error-primary",
      )}
      {...props}
    >
      {label}

      {isRequired && (
        <span aria-hidden="true" className="tw:text-text-error-primary">
          {` *`}
        </span>
      )}
    </Label>
  );
}

const labelStyles = tv({
  slots: {
    body: "tw:mb-0!",
  },
});
